
export async function clearImageCache() {
    console.log('a intrat in cache')
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(cache => caches.delete(cache)));
}